<template>
    <Layout>
        <b-row>
            <b-col xl="2" sm="3">
                <keep-alive>
                    <Menu @back="handleBack"/>
                </keep-alive>
            </b-col>

            <b-col xl="10"  sm="9">
                <!-- main component here -->
                <DistributionView />
            </b-col>
        </b-row>
    </Layout>
</template>

<script>
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import {layoutMethods} from '@/state/helpers';
import DistributionView from '@/components/documents/directDistributionView.vue'
export default {
    data:() => ({

    }),
    components:{
        Layout,
        Menu,
        DistributionView
    },
    computed: {
        
    },
    methods: {
        ...layoutMethods,
        handleBack(){
            alert(' use router.back or something like that')
        },
    },
    mounted(){
        this.$nextTick(()=>{
            this.updateMenuType({
                type: 'distribution',
                showMenu: true,
                showRoutes: false,
            })
        })
    },
    beforeDestroy(){
        this.updateMenuType({
            type: 'Nothing',
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>
